<template>
    <div>
        <az-empty-state v-if="!dados || !dados.length" icon="fas fa-user-clock" msg="Nenhum profissional identificado para agenda." />
            
        <table class="table bg-white table-hover cabecalho-fixo" v-else>
            <thead>
                <tr>
                    <th width="30%">Profissional</th>
                    <th>Especialidades</th>
                    <th>Agendas</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="(medico, idx) in dados" :key="idx">
                    <td>
                        {{ medico.st_nome_exibicao }}
                        <div class="small">
                            {{ medico.conselho ? medico.conselho.st_sigla : '' }}
                            {{ medico.in_numero_conselho }}-{{ medico.estado_conselho ? medico.estado_conselho.st_sigla : '' }}
                        </div>
                        <div class="small">
                            <span v-if="medico.medico_unidade.in_paciente_idade_minima || medico.medico_unidade.in_paciente_idade_maxima">
                                Pacientes: 
                                <span v-if="medico.medico_unidade.in_paciente_idade_minima && medico.medico_unidade.in_paciente_idade_maxima">
                                    {{ medico.medico_unidade.in_paciente_idade_minima }} a {{ medico.medico_unidade.in_paciente_idade_maxima }} anos
                                </span>
                                <span v-else-if="medico.medico_unidade.in_paciente_idade_minima">
                                    a partir de {{ medico.medico_unidade.in_paciente_idade_minima }} anos
                                </span>
                                <span v-else-if="medico.medico_unidade.in_paciente_idade_maxima">
                                    até {{ medico.medico_unidade.in_paciente_idade_maxima }} anos
                                </span>
                                <span v-if="medico.medico_unidade.ch_paciente_sexo" class="badge badge-secondary ml-1">
                                    {{ medico.medico_unidade.ch_paciente_sexo }}
                                </span>
                            </span>
                        </div>
                    </td>
                    <td class="col col-12 col-md-3">
                        <small v-if="lista(medico.medico_especialidade, 'especialidade.search')">
                            {{ lista(medico.medico_especialidade, 'especialidade.search') }}
                        </small>
                        <div v-else>
                            <i class="fas fa-exclamation-triangle text-warning mr-2"></i>
                            Nenhuma Especialidade Selecionada
                        </div>
                    </td>
                    <td>
                        <div class="small text-nowrap" v-for="(agenda, iax) in medico.agendas" :key="iax">
                            <a href="#" @click.prevent="editar_agenda(agenda, medico)">
                                {{ agenda.search }}, {{ dia_da_semana(agenda.in_dia_semana) }}, {{ agenda.in_tempo_atendimento }}{{ agenda.fl_ordem_chegada ? ' vagas' : 'min' }}
                            </a>
                        </div>
                        <button type="button" class="btn" @click="compor_agenda(medico)"
                            :class="medico.agendas.length ? 'btn-sm btn-outline-primary mt-2' : 'btn-primary'">
                            <i class="fa fa-plus" aria-hidden="true"></i>
                        </button>
                    </td>
                </tr>
            </tbody>
        </table>

        <cadastro-agendas ref="agenda" :setup="true" @refresh="load()" />
    </div>
</template>

<script>
import _ from 'lodash';
import CadastroAgendas from '../cadastros/items/CadastroAgendas.vue';

export default {
    data() { 
        return { 
            dados: null, 
        };
    },

    components: { 
        CadastroAgendas,
    },

    methods: { 
        editar_agenda(agenda, medico = null) { 
            let item = _.cloneDeep(agenda);

            if ( medico ) { 
                item.medico = { 
                    st_nome_exibicao: medico.st_nome_exibicao,
                };
            }

            this.$refs.agenda.editar(item);
        },

        compor_agenda(medico) { 

            let grupo = { 
                id_medico: medico.id_pessoa, 
                medico: medico,
            };

            this.$refs.agenda.comporAgenda(grupo);

        },

        lista (items, campo) { 
            return items.map(item => _.get(item, campo))
                .join(', ');
        },

        dia_da_semana(dia) { 
            switch (dia) {
                case 0: return 'Dom';
                case 1: return 'Seg';
                case 2: return 'Ter';
                case 3: return 'Qua';
                case 4: return 'Qui';
                case 5: return 'Sex';
                case 6: return 'Sáb';
                default: return dia;
            }
        },

        load() { 
          
            let query = { q: [] };

            query.q.push({ name: "medicos.index", id: "medicos", parms: { validacao: true, ativos: true, sem_agenda_compartilhada: true } });
      
            this.axios
                .post("/aql?a=validgeral.index", query)
                .then(res => {
                    if ( !res.data )
                        return;

                    this.dados = res.data.medicos.data;

                });

        },
    },

    mounted() { 
        this.load();
    }

}
</script>